import React from "react"

export const Center: React.FC<React.PropsWithChildren<unknown>> = (props) => {
  return <div className="flex items-center justify-center h-screen w-full">{props.children}</div>
}
